import React, { useEffect, useState } from "react";
import { Controller, useFieldArray } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Trash2, Printer } from "feather-icons-react/build/IconComponents";
import { PmBarcodeIcon, PmTranslateIcon } from "./pmUi";
import toast from "react-hot-toast";
import axios from "axios";
 
const EditProductProfile = ({ register, watch, control, errors, productName,setValue }) => {
  const animatedComponents = makeAnimated();
  const [products, setproducts] = useState([]);
  const { deliveyTypes, unitList, groupList, productList, categoryList,taxList } =
    useSelector((state) => state.usersetting);
 
  const comboType = deliveyTypes?.find((type) => type.name === "Combo"); // Find Combo type
  const COMBO_TYPE_ID = comboType?.guid; // Get Combo type GUID
 
  const API_KEY = process.env.REACT_APP_TRANSLATION_API_KEY;

  const languages = [
    { code: "ar", name: "Arabic" },
    // { code: "hi", name: "Hindi" },
    // { code: "ml", name: "Malayalam" },
  ];

    const handleTranslation = async (targetLanguage) => {
      if (!productName) {
        toast.error("Please enter a product name to translate.");
        return;
      }
  
      const url = `https://translation.googleapis.com/language/translate/v2?key=${API_KEY}`;
  
      try {
        const response = await axios.post(url, {
          q: productName,
          target: targetLanguage,},
      {
        // By setting `requireheader: false`, the global headers will be blocked
        requireheader: false,
      }
    );
  
      const translatedText = response.data.data.translations[0].translatedText;
      setValue("profile.shortName", translatedText); // Update Arabic Description
      toast.success("Translation completed!");
    } catch (error) {
      console.error("Translation error:", error.response?.data || error.message);
      toast.error("Error translating text");
    }
  };
  useEffect(() => {
    const newlist = productList?.map((e) => ({
      label: e.name,
      value: e.guid,
    }));
    setproducts(newlist);
  }, []);
  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

 
  const handleAddMore = () => {
    append({ name: "", maxItems: "", comments: "" });
  };
console.log(categoryList,"caaaaaaat");
 
  return (
    <div className="pm-panel">
      {/* ---------- identity ---------- */}
      <div className="pm-secthead">Identity</div>
      <div className="pm-formgrid">
        <div className="pm-f">
          <label className="pm-flabel">
            Name<span className="pm-req">*</span>
          </label>
          <input
            type="text"
            placeholder="Name"
            className={errors?.profile?.name ? "err" : ""}
            {...register("profile.name", { required: "Name is required" })}
          />
          {errors?.name && (
            <span className="error pm-errtext">{errors.name.message}</span>
          )}
        </div>

        <div className="pm-f">
          <label className="pm-flabel">Other Language</label>
          <div className="pm-inrow">
            <input
              type="text"
              placeholder=""
              className="pm-ar"
              dir="auto"
              // defaultValue={ShortDescription}
              value={watch("profile.shortName")}
              {...register("profile.shortName")}
            />
            {languages.map((lang) => (
              <button
                key={lang.code}
                type="button"
                className="pm-tbtn"
                onClick={() => handleTranslation(lang.code)}
              >
                <PmTranslateIcon />
                {lang.name}
              </button>
            ))}
          </div>
        </div>

        <div className="pm-f">
          <label className="pm-flabel">
            Code<span className="pm-req">*</span>
          </label>
          <input
            type="text"
            placeholder="Code"
            className={"pm-mono" + (errors?.profile?.prodCode ? " err" : "")}
            {...register("profile.prodCode", { required: "Code is required" })}
          />
          {errors?.code && (
            <span className="error pm-errtext">{errors.code.message}</span>
          )}
        </div>

        <div className="pm-f">
          <label className="pm-flabel" htmlFor="StockTypeID">
            Stock Type<span className="pm-req">*</span>
          </label>
          <select
            id="StockTypeID"
            className={errors?.profile?.stockTypeID ? "err" : ""}
            {...register("profile.stockTypeID", { required: "Stock Type is required" })}
          >
            <option value="" disabled>Select Stock Type</option>
            <option value="1">Stock</option>
            <option value="2">Non-Stock</option>
            <option value="3">Discontinued</option>
          </select>
          {errors?.StockTypeID && (
            <span className="error pm-errtext">{errors.StockTypeID.message}</span>
          )}
        </div>
      </div>

      {/* ---------- classification ---------- */}
      <div className="pm-secthead gap">Classification</div>
      <div className="pm-formgrid">
        <div className="pm-f">
          <label className="pm-flabel">
            Category<span className="pm-req">*</span>
          </label>
          <select
            {...register("profile.categoryID", { required: "Category is required" })}
            className={errors?.profile?.categoryID ? "err" : ""}
          >
            <option value="" disabled>
              Select Category
            </option>
            {categoryList?.map((category) => (
              <option key={category.guid} value={category.guid}>
                {category.name}
              </option>
            ))}
          </select>
          {errors?.category && (
            <span className="error pm-errtext">{errors.category.message}</span>
          )}
        </div>

        <div className="pm-f">
          <label className="pm-flabel">
            Item Type<span className="pm-req">*</span>
          </label>
          <select
            {...register("profile.itemTypeID", { required: "Item Type is required" })}
            className={errors?.profile?.itemTypeID ? "err" : ""}
          >
            <option value="" disabled>
              Select Type
            </option>
            {deliveyTypes?.map((type) => (
              <option key={type.guid} value={type.guid}>
                {type.name}
              </option>
            ))}
          </select>
          {errors?.type && (
            <span className="error pm-errtext">{errors.type.message}</span>
          )}
        </div>

        {watch().type === COMBO_TYPE_ID && (
          <>
            {fields?.map((item, index) => (
              <div className="pm-combo" key={index}>
                <div className="pm-f">
                  <label className="pm-flabel">Select Combo Products</label>
                  <Controller
                    {...register(`items[${index}].name`, {
                      required: watch().type === COMBO_TYPE_ID,
                    })}
                    name={`items[${index}].name`}
                    control={control}
                    render={({ field }) => (
                      <Select
                        closeMenuOnSelect={false}
                        {...field}
                        isMulti
                        components={animatedComponents}
                        placeholder="Select Combo Products"
                        options={products}
                      />
                    )}
                  />
                </div>
                <div className="pm-f">
                  <label className="pm-flabel">
                    Enter maximum number of items
                  </label>
                  <input
                    type="number"
                    min={0}
                    id={`items[${index}].maxItems`}
                    {...register(`items[${index}].maxItems`, {
                      required: watch().type === COMBO_TYPE_ID,
                    })}
                    className="pm-num"
                    placeholder="Enter maximum number of items"
                  />
                </div>
                {index > 0 ? (
                  <button
                    type="button"
                    onClick={() => remove(index)}
                    className="pm-iconsq"
                    aria-label="Remove side choice"
                  >
                    <Trash2 />
                  </button>
                ) : (
                  <span />
                )}
              </div>
            ))}
            <div className="pm-combo-add">
              <button type="button" onClick={handleAddMore} className="pm-gbtn">
                Add More Side Choice
              </button>
            </div>
          </>
        )}
        {/* Conditionally render AddCombo */}

        <div className="pm-f">
          <label className="pm-flabel">Group</label>
          <select
            {...register("profile.subGroupID", { required: "Group is required" })}
            className={errors?.profile?.subGroupID ? "err" : ""}
          >
            <option value="" disabled>
              Select Group
            </option>
            {groupList?.map((group) => (
              <option key={group.guid} value={group.guid}>
                {group.name}
              </option>
            ))}
          </select>
        </div>

        <div className="pm-f">
          <label className="pm-flabel">
            Base Unit<span className="pm-req">*</span>
          </label>
          <select
            {...register("profile.unitID", {
              required: "Base Unit is required",
            })}
            className={errors?.profile?.unitID ? "err" : ""}
          >
            <option value="" disabled>
              Select Unit
            </option>
            {unitList?.map((unit) => (
              <option key={unit.guid} value={unit.guid}>
                {unit.name}
              </option>
            ))}
          </select>
          {errors?.unit && (
            <span className="error pm-errtext">{errors.unit.message}</span>
          )}
        </div>
      </div>

      {/* ---------- pricing & tax ---------- */}
      <div className="pm-secthead gap">Pricing &amp; tax</div>
      <div className="pm-formgrid">
        <div className="pm-f">
          <label className="pm-flabel">Cost</label>
          <input
            type="number"
            placeholder=""
            min={0}
            className="pm-num"
            defaultValue={0}
            {...register("profile.avgCost", { required: "cost is required" })}
          />
        </div>

        <div className="pm-f">
          <label className="pm-flabel">Tax</label>
          <select
            {...register("profile.taxID", { required: "Category is required" })}
            className={errors?.profile?.taxID ? "err" : ""}
          >
            <option value="" disabled>
              Select Tax
            </option>
            {taxList?.map((category) => (
              <option key={category.guid} value={category.guid}>
                {category.name}
              </option>
            ))}
          </select>
        </div>

        <div className="pm-f">
          <label className="pm-flabel">Retail Price</label>
          <input
            type="number"
            className="pm-num"
            placeholder=""
            min={0}
            step="00.001"
            defaultValue={0}
            {...register("profile.retailRate")}
          />
        </div>

        <div className="pm-f">
          <label className="pm-flabel">Wholesale Price</label>
          <input
            type="number"
            className="pm-num"
            placeholder=""
            min={0}
            step="00.001"
            defaultValue={0}
            {...register("profile.wsRate")}
          />
        </div>

        <div className="pm-f full">
          <label className="pm-switch">
            <input type="checkbox" {...register("profile.isSalesTaxIncludedInPrice")} />
            <span className="pm-track" />
            Tax Included In Sales Price
          </label>
        </div>
        {/* <div className="col-md-6 col-sm-12">
          <div className="input-blocks d-flex align-items-center">
            <input type="checkbox" {...register("otherDescription.isPurchaseTaxIncludedInPrice")} />
            <label className="ms-2 mb-1">Purchase Rate</label>
          </div>
        </div> */}
      </div>

      {/* ---------- barcodes ---------- */}
      <div className="pm-secthead gap">Barcodes</div>
      <div className="pm-formgrid">
        <div className="pm-f">
          <label className="pm-flabel">
            UBC<span className="pm-req">*</span>
          </label>
          <div className="pm-inrow">
            <input type="text" placeholder="" className="pm-mono" {...register("profile.ubc")} />
            <button type="button" className="pm-tbtn">
              <PmBarcodeIcon />
              Generate
            </button>
            <button type="button" className="pm-gbtn">
              <Printer />
              Print
            </button>
          </div>
        </div>

        <div className="pm-f">
          <label className="pm-flabel">
            SBC<span className="pm-req">*</span>
          </label>
          <div className="pm-inrow">
            <input type="text" placeholder="" className="pm-mono" {...register("profile.sbc")} />
            <button type="button" className="pm-tbtn">
              <PmBarcodeIcon />
              Generate
            </button>
            <button type="button" className="pm-gbtn">
              <Printer />
              Print
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default EditProductProfile;
 